import Swiper, {Navigation, Autoplay} from 'swiper';

Swiper.use([Navigation, Autoplay])

export default class Home {
    constructor() {
        this.slider()
        this.hero();
    }

    slider() {
        if (document.querySelector('#new-objects')) {
            const slider = new Swiper('#new-objects .swiper-container', {
                // initialSlide: 1,
                // loop: true,
                sliderPerView: 1,
                spaceBetween: 50,
                breakpoints: {

                    // when window width is >= 640px
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },

                },
                navigation: {
                    nextEl: '#new-objects .swiper-button-next',
                    prevEl: '#new-objects .swiper-button-prev',
                },
            });
        }

        if (document.querySelector('#services')) {
            const slider = new Swiper('#services .swiper-container', {

                sliderPerView: 1,
                spaceBetween: 30,
                breakpoints: {
                    // when window width is >= 640px
                    576: {
                        slidesPerView: 1.5,
                        spaceBetween: 15
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    }
                }
            });
        }

        if (document.querySelector('#social-media')) {
            const slider = new Swiper('#social-media .swiper-container', {
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },
                sliderPerView: 1,
                spaceBetween: 30,
                breakpoints: {

                    // when window width is >= 640px
                    576: {
                        slidesPerView: 2
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    }

                },
                navigation: {
                    nextEl: '#social-media .swiper-button-next',
                    prevEl: '#social-media .swiper-button-prev',
                },
            });
        }
    }

    hero() {
        if (document.querySelector('#homepage #hero')) {
            const slider = new Swiper('#hero .swiper-container', {
                sliderPerView: 1,
                autoplay: {
                    disableOnInteraction: false,
                    delay: 6000
                }
            });
        }
    }
}
